import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main className="not-found">
      <p className="not-found__code">404</p>
      <h1>That page isn't on the list.</h1>
      <p>The link may have changed. Find a venue or head back to the homepage.</p>
      <Link to="/">Explore venues</Link>
    </main>
  );
}
